import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../../../commonComponents/translate';
import Modal from '../../../../commonComponents/modal/Modal';
import { displayUserName } from '../../../../services/utilityFunctions';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import CloseIcon from '../../../../commonComponents/icons/icon/CloseIcon';
import UserColumn from '../../../../commonComponents/lists/columns/UserColumn';

function InfoSection(props) {
  const { type, label, value } = props;
  return (
    <div className="info-section">
      <h6 className={type}>{label}</h6>
      <p>{value ? value.toFixed(2) : '0'}</p>
    </div>
  );
}

InfoSection.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
};
InfoSection.defaultProps = {
  value: null,
};

function NFTInfoSection(props) {
  const { color, backgroundColor, label, value } = props;
  return (
    <div className="nft-info-section" style={{ backgroundColor }}>
      <h6 style={{ color }}>{label}</h6>
      <p>{value}</p>
    </div>
  );
}

NFTInfoSection.propTypes = {
  color: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

function DetailModal(props) {
  const { t, onClose, user } = props;
  const {
    access,
    userType,
    sponsoredBy,
    levelInfo,
    serviceEndDate,
    nftRetail,
    nftTrading,
    nftWatches,
    nftEvent,
    nftRealEstate,
    web3,
    levelDate,
  } = user;

  const hasWeb3 = () => access?.some(item => item?.name === 'WEB3') ?? false;

  const hasStartOrPremiumOrElite = () => {
    // const namesToCheck = [
    //   'Start LV',
    //   'Start',
    //   'Elite',
    //   'Premium',
    //   'VIP',
    //   'INNER CIRCLE',
    // ];

    return false; // access?.some(item => namesToCheck.includes(item?.name)) ?? false;
  };

  const { icon, name } = levelInfo || {};
  return (
    <Modal onClose={onClose} id="neofinDetailModal">
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modalTitle">
            <h5 className="title">{displayUserName(user)}</h5>
            <button type="button" onClick={onClose} className="closeIcon">
              <CloseIcon width="20" height="20" color="#6C7293" />
            </button>
          </div>
          <div
            id="modalBody"
            className="modal-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <div className="container-fluid">
              <div className="header-container">
                <div className="section">
                  <h6>{t('user.type')}</h6>
                  <p>{userType}</p>
                </div>
                <div className="section">
                  <h6>{t('sponsor')}</h6>
                  {sponsoredBy ? (
                    <UserColumn t={t} user={sponsoredBy} />
                  ) : (
                    ' - '
                  )}
                </div>
                <div className="section">
                  <h6>{t('level')}</h6>
                  {levelInfo?.name ? (
                    <div className="level-container">
                      <img src={icon} alt={name} />
                      <p>{name}</p>
                    </div>
                  ) : (
                    <p> - </p>
                  )}
                </div>
                <div className="section">
                  <h6>{t('report.neofin.endService')}</h6>
                  <p>
                    {serviceEndDate
                      ? moment(serviceEndDate).format('DD MMM YYYY')
                      : ' - '}
                  </p>
                </div>
                <div className="section">
                  <h6>{t('report.neofin.dateLevelMax')}</h6>
                  <p>
                    {levelDate ? moment(levelDate).format('MMM YYYY') : ' - '}
                  </p>
                </div>
              </div>
              <div className="info-container">
                <InfoSection
                  type="myVA"
                  label={t('commissions.myVA')}
                  value={user?.forecast?.myVA}
                />
                <InfoSection
                  type="directVA"
                  label={t('commissions.directVA')}
                  value={user?.forecast?.personalVA}
                />
                <InfoSection
                  type="sponsorVA"
                  label={t('commissions.sponsorVA')}
                  value={user?.forecast?.groupVA}
                />
                <InfoSection
                  type="VALeft"
                  label={t('commissions.vaLeft')}
                  value={user?.forecast?.VALeft}
                />
                <InfoSection
                  type="VARight"
                  label={t('commissions.vaRight')}
                  value={user?.forecast?.VARight}
                />
                {hasStartOrPremiumOrElite() && (
                  <>
                    <NFTInfoSection
                      color="#2AD1A5"
                      backgroundColor="#2AD1A51A"
                      label={t('report.neofin.nftRetail')}
                      value={nftRetail}
                    />
                    <NFTInfoSection
                      color="#FFBD06"
                      backgroundColor="#FFBD061A"
                      label={t('report.neofin.nftTrading')}
                      value={nftTrading}
                    />
                    <NFTInfoSection
                      color="#007EB4"
                      backgroundColor="#007EB41A"
                      label={t('report.neofin.nftWatches')}
                      value={nftWatches}
                    />
                    <NFTInfoSection
                      color="#6944FF"
                      backgroundColor="#6944FF1A"
                      label={t('report.neofin.nftEvent')}
                      value={nftEvent}
                    />
                    <NFTInfoSection
                      color="#FF6C02"
                      backgroundColor="#FF6C021A"
                      label={t('report.neofin.nftRealEstate')}
                      value={nftRealEstate}
                    />
                  </>
                )}
                {hasWeb3() && (
                  <NFTInfoSection
                    color="#79B928"
                    backgroundColor="#79B9281A"
                    label={t('report.neofin.web3')}
                    value={web3}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

DetailModal.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
  onClose: PropTypes.func.isRequired,
};
DetailModal.defaultProps = {};

export default translate(DetailModal);
